<script>
  import { layoutMethods, customerListComputed,customerMethods,exportMethods,erpFixMessages} from "@/state/helpers";
  import Swal from 'sweetalert2';
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import moment from 'moment-timezone';
  // import DatePicker from 'vue-bootstrap-datetimepicker';
  // import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

  /**
   * MDR Settings component
   */
  export default {
    page: {
      title: "MDR Settings"
    },
    components: {
      flatPickr,
      // DatePicker,
    },
    computed: {
      ...customerListComputed,
      ...erpFixMessages,
      isMdrPerpetual: {
        get(){
          var isPerpetual = 0;
          if(this.mdrOptions.length){
            this.mdrOptions.forEach(el => { 
              if(el.value == this.mdrForm.mdr){
                isPerpetual = el.isPerpetual
              }
            })
          }
          return isPerpetual
        }
      },
      isWatchlisted: {
        get (){
          return this.businessDetails.mdr?.isWatchlisted??false;
        },
        set(value){
          this.businessDetails.mdr["isWatchlisted"] = value;
        }
      },
      mdrOptions: {
        get (){
          return this.mdrOptionsOrg.map((res)=>{
            if(!res.text.includes("MDR")){
              // res["disabled"] = this.isWatchlisted;
            }
            return res
          })
        },
        set(value){
          this.mdrOptionsOrg = value;
        }
      }

    },
    data() {
      return {
        title: "MDR Settings",
        mdrOptionsOrg: [
          // { text: 'Default - No MDR', value: 0 },
          // { text: '1% MDR Capped at 15', value: 1 },
        ],
        selectedMdr: 1,
        mdrForm:{
          mdr: 1,
          startAt:null,
          endAt:null,
        },
        mdrSearch:{
          dateRange:null,
          sort: 'id',
          orderDesc: true,
          page: 1,
          rows: 10,
        },
        rangeOptions: {
          mode: "range",
        },
        fields: [
          { key: "modifiedBy", sortable: true},
          { key: "modifiedDate", sortable: true, label:"Modified Date & Time"},
          { key: "mdr", sortable: false, label:"MDR"},
          { key: "effectiveDate", sortable: false},
        ],
        tableData:[],
        tableTotal:0,
        sortBy: "value",
        sortDesc: false,
        ruleObject: {
          required: true
        }
      };
    },
    methods: {
      ...layoutMethods,
      ...customerMethods,
      ...exportMethods,
      openModal(modal=''){
        switch (modal) {
          case 'bv-modal-mdr-logs':
            this.onSearch("reset");
            break;
        
          case 'bv-modal-mdr-settings-edit':
            // console.log("this.businessDetails.mdr",this.businessDetails.mdr);
            this.mdrForm.mdr = this.businessDetails.mdr?.mdrId??1;
            this.mdrForm.startAt = this.businessDetails.mdr?.startAt??null;
            this.mdrForm.endAt = this.businessDetails.mdr?.endAt??null;
            // this.fetchMDR();
            break;
          default:
            break;
        }
        this.$bvModal.show(modal);
      },
      closeModal(modal=''){
        this.$bvModal.hide(modal);
      },
      async submitChanges(){
        // console.log("FORM",this.mdrForm);
        // console.log("DATE",
        //   moment(this.mdrForm.startAt).tz('UTC').format("YYYY-MM-DD HH:mm:ss"),
        //   moment(this.mdrForm.endAt).tz('UTC').format("YYYY-MM-DD HH:mm:ss")
        // )
        await this.updateMdrWhitelist({
            // status: this.selectedMdr,
            mdr     : this.mdrForm.mdr,
            startAt : moment(this.mdrForm.startAt).tz('UTC').format("YYYY-MM-DD HH:mm:ss"),
            endAt   : moment(this.mdrForm.endAt).tz('UTC').format("YYYY-MM-DD HH:mm:ss"),
            cognitoSub: this.businessDetails.cogUserSub
        }).then((res)=>{
          console.log(`:: updateMdrWhitelist :: `, JSON.stringify(res));
          Swal.fire({
            title: "MDR Saved Successfully",
            html: `Your selected Merchant Discount Rate (MDR) has been saved successfully.`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: '#804997',
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
              console.log("><><>>>>>",this.businessDetails)
              this.getBusinessDetailsv2({id: this.businessDetails.businessId});
            }
          });
        }).catch((e)=>{
          console.log("ERror:",e);
          Swal.fire("Failed!", e.description || `Unable to update user MDR`, "warning");
        })

        this.closeModal('bv-modal-mdr-settings-edit')//*/
      },
      async fetchMDR(){
        // let self = this;
        await this.getKankolekMDR().then((res)=>{
          // console.log("getKankolekMDR",res);
          this.mdrOptions = res?.mdrOptions??[];
        });
      },
      getValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      },
      async onSearch(state = ''){
          if(state == 'reset'){
            this.mdrSearch.page = 1;
          }
          // console.log("onsearch",JSON.stringify(this.mdrSearch));
          await this.getKankolekMdrLogs({
            ...this.mdrSearch,
            cognitoSub: this.businessDetails.cogUserSub
          }).then((res)=>{
            // console.log("getKankolekMdrLogs:",JSON.stringify(res));
            this.tableData = res.rows;
            this.tableTotal= res.pageInfo.total;
          }).catch((err)=>{
            console.log("ERR getKankolekMdrLogs:",err);
          })
      },
      tableSort(ctx){//context
        if(ctx.sortBy.length > 1){
          this.mdrSearch.sort = ctx.sortBy;
          this.mdrSearch.orderDesc = ctx.sortDesc;
          // console.log(">> sorting...",ctx);
          this.onSearch('reset');
        }
      },
      async onExport(){
        await this.onSearch();
        if(this.tableTotal ==0){
          Swal.fire("Failed!", this.exportNullPrompt, "warning");
          return;
        }
        let params = Object.assign(
          this.mdrSearch,
          {
            module: 'user_kankolek_mdr_logs',
            email: JSON.parse(localStorage.getItem('userData')).email,
            cognitoSub: this.businessDetails.cogUserSub
          });

        
        this.exportReportExt(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      },
      async toggleWatchlist(){
        Swal.fire({
            title: 'Are you sure?',
            text: !this.isWatchlisted ? `Do you want to add this user to the watchlist?` : `Do you want to remove the user from the watchlist?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '##804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(async (result) => {
            if (result.isConfirmed) {
              // console.log(this.businessDetails);
              await this.updateWatchlistStatus({
                cognitoSub : this.businessDetails?.cogUserSub,
              }).then((res)=>{
                console.log(":: res ::",res?.isWatchlisted,JSON.stringify(res))
                Swal.fire("Success!", `Successfully updated the user's watchlist status.`, "success");
                this.getBusinessDetailsv2({id: this.businessDetails.businessId});
              }).catch((err)=>{
                this.isWatchlisted = !this.isWatchlisted
                console.log(":: err ::",err)
                Swal.fire("Failed!", err?.message?.description || `Unable to update the user's watchlist status.`, "warning");
              })
            }else{
              this.isWatchlisted = !this.isWatchlisted
            }
        })
      }
    },
    async mounted(){
        this.fetchMDR();
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
    <div class="card">
      <div class="d-flex border-top p-2 px-3 border-bottom text-dark">
          <div class="flex-grow-1 my-auto pt-1 row">
              <h5 class="mb-0 font-size-14 col-6 mt-1">MDR Settings</h5>
              <div class="mb-1 col-6 text-end">
                  <b-link class="small fw-semibold text-primary" @click="openModal('bv-modal-mdr-settings-edit')">Edit</b-link>
              </div>
          </div>
      </div>
      <ul class="list-unstyled mb-0">
          <li class="py-3 p-2 px-3 pb-0"  >
            <div class="float-end text-end">
              <input type="checkbox" id="watchlisted" switch="bool" checked="checked" v-model="isWatchlisted" @click="toggleWatchlist"/>
              <label for="watchlisted" data-on-label="On" data-off-label="Off" class="mb-0"></label>
            </div>
            <p class="fw-semibold m-0">
              Watchlist
              <i 
                class="fa fa-info-circle mx-" 
                aria-hidden="true" 
                v-b-tooltip.hover 
                title="When a user is watchlisted, he/she won't be able to switch his/her pricing model and will remain an MDR user until the user is removed from the watchlist."
                >
              </i>
            </p>
          </li>
          <li class="py-3 p-2 px-3 border-bottom pb-0"> 
            <p class="fw-semibold m-0">MDR</p>
            <div class="mdr-custom mb-4">
              {{ 
                  ((businessDetails.mdr?.isWhitelisted?? false) && (businessDetails.mdr?.onMdr?? false) ?
                  `${businessDetails.mdr.mdrName}`:
                  "Default - Kolek Fee")
                  | notEmpty
              }}
            </div>
          </li>
          <li class="py-3 p-2 px-3 border-bottom pb-0"> 
            <p class="fw-semibold m-0">Effective Date & Time:</p>
            <div class="mb-4">
              {{ businessDetails.mdr?.startAt??null | formatDateNoComma }} - 
              {{ businessDetails.mdr?.endAt??null | formatDateNoComma }}
            </div>

          </li>
          <!-- end li -->
          <li class="py-3 p-2 px-3"> <!-- Activity log -->
              <div class="d-flex align-items-center">
                  <div class="flex-grow-1 row">
                      <p class="mb-1 font-size-13 col-6">Activity log:</p>
                      <div class="mb-1 col-6 text-end">
                          <b-link class="small fw-semibold text-primary" @click="openModal('bv-modal-mdr-logs')">View</b-link>
                      </div>
                  </div>
              </div>
          </li>
          <!-- end li -->
      </ul>
    </div>


    <b-modal id="bv-modal-mdr-settings-edit"
      size="md"
      centered
      hide-header
      hide-footer
      hide-header-close
    >

        <div class="text-center">
          <i class="text-info bx bx-info-circle" style="font-size: 90px;"></i>
          <h4 class="fw-semibold text-black my-3">MDR Settings</h4>
          <p>Please select one of the following Merchant Discount Rate (MDR) options for the merchant's account:</p>
        </div>
        <ValidationObserver v-slot="{ handleSubmit, reset }">
          <b-form @submit.prevent="handleSubmit(submitChanges)" @reset.prevent="reset">
            <validation-provider name="MDR" rules="required" v-slot="validationContext">
              <div class="px-3 mb-4">
                  <label>Select MDR <span class="text-danger">*</span></label>
                  <b-form-group>
                    <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                      v-model="mdrForm.mdr"
                      :options="mdrOptions"
                      :state="getValidationState(validationContext)"
                    ></b-form-select>
                  </b-form-group>
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
              </div>
            </validation-provider>

            <validation-provider name="Start at" rules="required" v-slot="validationContext" v-if="mdrForm.mdr > 1 && !isMdrPerpetual && !isWatchlisted">
              <div class="px-3 mb-4">
                  <label>Start Date<span class="text-danger">*</span></label>
                  <input type="hidden" :state="getValidationState(validationContext)" v-model="mdrForm.startAt" class="form-control"/>
                  <flat-pickr
                        :class="{'is-invalid': getValidationState(validationContext) === false}"
                        v-model="mdrForm.startAt"
                        placeholder="Select start date"
                        class="form-control ps-2 rounded-end"
                        :config="{minDate: businessDetails.mdr?.startAt?? 'today',maxDate:mdrForm.endAt == null ? null:mdrForm.endAt,enableTime: true}"
                  ></flat-pickr>
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
              </div>
            </validation-provider>
            <validation-provider name="End at" rules="required" v-slot="validationContext" v-if="mdrForm.mdr > 1 && !isMdrPerpetual && !isWatchlisted">
              <div class="px-3 mb-4">
                <label>End Date<span class="text-danger">*</span></label>
                <input type="hidden" :state="getValidationState(validationContext)" v-model="mdrForm.endAt" class="form-control"/>
                <flat-pickr
                      v-model="mdrForm.endAt"
                      placeholder="Select end date"
                      class="form-control ps-2 rounded-end"
                      :config="{minDate: mdrForm?.startAt?? 'today',enableTime: true}"
                      :class="{'is-invalid': getValidationState(validationContext) === false}"
                  ></flat-pickr>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </div>
            </validation-provider>
            <div class="text-center">
              <b-button
                type="button"
                variant="dark"
                @click="closeModal('bv-modal-mdr-settings-edit')"
                class="me-2"
              >
                Cancel
              </b-button>
              <b-button
                type="submit"
                variant="primary"
              >
                Save
              </b-button>
            </div>
          </b-form>
        </ValidationObserver>
    </b-modal><!--bv-modal-mdr-update-->

    <b-modal id="bv-modal-mdr-logs"
      size="xl"
      centered
      hide-header
      hide-footer
      hide-header-close
    >
        <div class="row">
          <h5 class="fw-semibold text-black my-3 col-12">MDR Activity Log: {{ tableTotal }} Record(s)</h5>
          <div class="col-12 d-flex flex-wrap mt-3 mb-2 px-3">
            <div class="me-2 ta-right"><!--filter by date modified-->
              <b-form-group description="Filter by date modified">
                  <flat-pickr
                    v-model="mdrSearch.dateRange"
                    placeholder="Filter by date modified"
                    class="form-control"
                    style="width: 250px;"
                    :config="rangeOptions"
                  ></flat-pickr>
              </b-form-group>
            </div><!--filter date modified-->

            <div class="me-2">
              <a class="btn btn-primary h-fit" @click="onSearch('reset')">
                <i class='bx bx-search bx-fw'></i>Search
              </a>
            </div>
            <div class="me-2">
              <b-form-group label="">
                <b-button variant="primary" type="button" class="px-2 btn btn-primary h-fit" @click="onExport">
                  <i class='uil uil-export me-1'></i> Export
                </b-button>
              </b-form-group>
            </div>
          </div>
          <div class="col-12">
            <b-table
                  :items="tableData"
                  :fields="fields"
                  responsive="sm"
                  :current-page="mdrSearch.page"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  class="table-check"
                  @sort-changed="tableSort"
                >

              <template #cell(effectiveDate)="data">
                {{ data.item.startDate |  formatDateNoComma}}
                -
                {{ data.item.endDate |  formatDateNoComma}}
              </template>
              <template #cell(modifiedDate)="data">
                {{ data.item.modifiedDate |  formatDateNoComma}}
              </template>
            </b-table>
            <div class="row g-0 text-center" v-if="tableTotal == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start" v-if="tableTotal != 0 && tableTotal > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end" 
                    >
                      <!-- pagination -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="mdrSearch.page"
                        :total-rows="tableTotal"
                        :per-page="mdrSearch.rows"
                        @input="onSearch"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
          </div>
        </div>
    </b-modal>
  </div> <!-- end of outer div-->
</template>

<style>
.mdr-custom{
  background: #E1E1E1;
  padding: 10px;
  border-radius: 4px;
}
</style>